<div [formGroup]="templateForm" class="main-container">
    <p-toast></p-toast>
    <div>
        Name
        <input pInputText formControlName="name">
        Language: <p-dropdown placeholder="select language" [options]="languages" formControlName="language"
            optionLabel="name"></p-dropdown>
    </div>
    <div>
        Subject:
    </div>
    <div>
        <input pInputText formControlName="subject" class="subject-input">
    </div>
    <div>
        <span>
            Background:
        </span>
        <p-dropdown placeholder="None" [options]="colors" appendTo="body" [showClear]="true" (onChange)="updateBackgroundColor($event.value)">
            <ng-template pTemplate="selectedItem">
                <div class="color-label-container"  *ngIf="templateForm.value.backgroundColor">
                    <div [style]="{backgroundColor: templateForm.value.backgroundColor, width:'20px', height: '20px'}"></div>
                    <span>
                        {{templateForm.value.backgroundColor}}
                    </span>
                </div>
            </ng-template>
            <ng-template let-color pTemplate="item">
                <div class="color-label-container">
                    <div [style]="{backgroundColor: color, width:'20px', height: '20px'}"></div>
                    <span>
                        {{color}}
                    </span>
                </div>
            </ng-template>
        </p-dropdown>
        <input pInputText formControlName="backgroundColor">
    </div>
    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
    <p-button label="Submit" (onClick)="postTemplate()" [disabled]="processing"></p-button>
</div>